import { useSyncExternalStore } from 'react';

// Second clause: a phone turned sideways is wider than 600px but still a phone.
const PHONE_QUERY = '(max-width: 599px), (pointer: coarse) and (max-height: 599px)';

function subscribe(onChange: () => void) {
  const mql = window.matchMedia(PHONE_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

export function useIsPhone(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(PHONE_QUERY).matches,
    () => false
  );
}
